import React, { useContext } from 'react'
import { EventAgendaContext } from '@/component/Context/EventAgendaContext'
import { string, array, number, shape } from 'prop-types'
import styles from '../EventAgenda.module.scss'
import Type from '@/component/Primitive/Type'
import cx from 'classnames'

export const TimelineBox = (props) => {
  const {
    name,
    speakers,
    c1,
    c2,
    r1,
    r2,
    currentTime,
    timezone,
    registerButtonClassName,
    timeRange
  } = props
  const { handleOpenModal, setEventAgendaModalItem } = useContext(
    EventAgendaContext
  )

  const handleClick = () => {
    setEventAgendaModalItem({
      ...props,
      location: props.location.name,
      sessionType: props.sessionType.name,
      timezone,
      registerButtonClassName,
      time: timeRange
    })
    handleOpenModal()
  }

  const formatSpeakers = (speakers) => {
    return speakers.map((speaker) => speaker?.name).join(', ')
  }

  const isLive = () => {
    if (!currentTime) return false
    return currentTime.c1 >= c1 && currentTime.c1 < c1 + c2
  }

  return (
    <button
      className={cx(styles.TimelineBox, isLive() && styles.live)}
      style={{
        gridColumn: `${c1} / span ${c2}`,
        gridRow: `${r1} / span ${r2}`
      }}
      onClick={() => handleClick()}
    >
      <Type
        className={styles.TimelineBoxName}
        weight="medium"
        size={['body3', 'body3']}
      >
        {name}
      </Type>
      {!!speakers.length && (
        <Type className={styles.TimelineBoxSpeakers} size={['body3', 'body3']}>
          {formatSpeakers(speakers)}
        </Type>
      )}
    </button>
  )
}

TimelineBox.propTypes = {
  name: string,
  speakers: array,
  c1: number,
  c2: number,
  r1: number,
  r2: number,
  currentTime: shape({
    c1: number,
    c2: number
  }),
  location: shape({
    name: string
  }),
  sessionType: shape({
    name: string
  }),
  timezone: string,
  registerButtonClassName: string,
  timeRange: string
}
